/* 极简挂件拖动：不吞点击，支持 iframe
 *
 * 用法：把 TARGETS 换成你的挂件选择器，整段塞进 Shopify 自定义脚本 / 主题里即可。
 *  - 普通元素：直接拖本体，点击完全不受影响
 *  - iframe：拖它上方那条小横条（iframe 内部的事件父页面拿不到，这是唯一不破坏点击的做法）
 *  - 位置用 CSS translate 属性写，不干扰元素自身的 transform / scale / 动画
 */
(function () {
  "use strict";

  var TARGETS = [
    { sel: "#loloyal-launcher-box" }, // 普通元素
    { sel: "#quick-chat-iframe", iframe: true }, // iframe：拖上方横条
  ];

  var THRESHOLD = 8; // 移动超过 8px 才算拖动，手抖不会被误判成拖动
  var CAN_TRANSLATE = !!(window.CSS && window.CSS.supports && window.CSS.supports("translate", "1px 1px"));

  function clamp(v, a, b) {
    return b < a ? a : Math.min(Math.max(v, a), b);
  }

  // 穿透 shadow DOM 找元素（挂件常挂在 shadow root 里）
  function deepFind(sel, root, depth) {
    root = root || document;
    depth = depth || 0;
    if (depth > 6) return null;
    var hit = root.querySelector(sel);
    if (hit) return hit;
    var all = root.querySelectorAll("*");
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var found = deepFind(sel, all[i].shadowRoot, depth + 1);
        if (found) return found;
      }
    }
    return null;
  }

  function baseTransformOf(el) {
    var t = window.getComputedStyle(el).transform;
    return t && t !== "none" ? t : "";
  }

  function moveTo(el, x, y) {
    if (CAN_TRANSLATE) {
      // translate 属性独立于 transform，元素自带 scale/rotate 时位移不会被放大或转向
      el.style.setProperty("translate", x + "px " + y + "px", "important");
    } else {
      var base = el.__dragBase || "";
      el.style.setProperty("transform", "translate3d(" + x + "px," + y + "px,0) " + base, "important");
    }
  }

  // 未位移时的矩形 + 视口尺寸，用来算拖动边界
  function limits(el, x, y) {
    var r = el.getBoundingClientRect();
    return {
      bl: r.left - x,
      bt: r.top - y,
      w: r.width,
      h: r.height,
      vw: document.documentElement.clientWidth,
      vh: document.documentElement.clientHeight,
    };
  }

  // PC 上拖完松手，浏览器还会补一次 click，只吃掉紧跟着的那一次
  function swallowClick(el) {
    var kill = function (ev) {
      ev.stopPropagation();
      ev.stopImmediatePropagation();
      if (ev.cancelable) ev.preventDefault();
    };
    el.addEventListener("click", kill, true);
    setTimeout(function () {
      el.removeEventListener("click", kill, true);
    }, 350);
  }

  /* ------------------------- 普通元素：拖本体 ------------------------- */
  function bindElement(el) {
    if (el.__dragBound) return;
    el.__dragBound = true;
    el.__dragBase = baseTransformOf(el);

    var x = 0,
      y = 0; // 当前位移
    var px = 0,
      py = 0; // 按下时的位移
    var sx = 0,
      sy = 0; // 按下时的指针坐标
    var pid = null; // 跟谁走（多指只认按下那根）
    var moving = false;

    el.style.setProperty("touch-action", "none", "important");
    el.style.setProperty("user-select", "none", "important");
    el.style.setProperty("-webkit-user-select", "none", "important");
    el.style.setProperty("cursor", "grab", "important");
    el.style.setProperty("-webkit-user-drag", "none", "important");

    // img / a 默认是浏览器原生可拖拽对象。按住图片拖动时浏览器会先起 dragstart，
    // 紧接着派 pointercancel，我们挂在 window 上的 pointermove 就断了 —— 表现为"点图片拖不动"。
    // 必须在捕获阶段拦掉，并给内部所有可拖拽节点标 draggable=false。
    el.addEventListener(
      "dragstart",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    // 你的挂件里图片在 #shadow-root (open) 内部，所以查询要落到 shadowRoot 上，
    // 同时往 shadow 里注入一条规则，后插入的图标也能覆盖。
    function noNativeDrag(root) {
      if (root.shadowRoot && !root.__dragStyleDone) {
        root.__dragStyleDone = true;
        var st = document.createElement("style");
        st.textContent = "img,picture,a,svg{-webkit-user-drag:none !important;user-drag:none !important;" + "-webkit-touch-callout:none !important;}";
        root.shadowRoot.appendChild(st);
      }

      var scope = root.shadowRoot || root;
      var nodes = scope.querySelectorAll("img, picture, a[href], svg");
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        n.setAttribute("draggable", "false");
        n.style.setProperty("-webkit-user-drag", "none", "important");
        n.style.setProperty("-webkit-touch-callout", "none", "important"); // 防 iOS 长按弹"存储图像"
      }
    }

    function watchNativeDrag() {
      noNativeDrag(el);
      if (!window.MutationObserver || el.__dragMo) return;
      el.__dragMo = new MutationObserver(function () {
        noNativeDrag(el);
      });
      el.__dragMo.observe(el, { childList: true, subtree: true });
      if (el.shadowRoot) el.__dragMo.observe(el.shadowRoot, { childList: true, subtree: true });
    }
    watchNativeDrag();
    setTimeout(watchNativeDrag, 800); // shadow root 可能是后 attach 的
    setTimeout(watchNativeDrag, 2500);

    function place(nx, ny) {
      var L = limits(el, x, y);
      x = clamp(nx, -L.bl, L.vw - L.bl - L.w);
      y = clamp(ny, -L.bt, L.vh - L.bt - L.h);
      moveTo(el, x, y);
    }

    function onMove(e) {
      if (e.pointerId !== pid) return;
      var dx = e.clientX - sx;
      var dy = e.clientY - sy;

      if (!moving) {
        if (Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) return;
        moving = true; // 到这里才确认是拖动
        el.style.setProperty("cursor", "grabbing", "important");
      }
      if (e.cancelable) e.preventDefault(); // 只在拖动中拦截，点击全程不碰
      place(px + dx, py + dy);
    }

    function onUp(e) {
      if (pid !== null && e.pointerId !== pid) return;
      pid = null;
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
      window.removeEventListener("pointercancel", onUp);
      if (!moving) return; // 没动过 = 一次正常点击，什么都不做
      moving = false;
      el.style.setProperty("cursor", "grab", "important");
      swallowClick(el);
    }

    // 按下时只记录：不 preventDefault、不 setPointerCapture
    // 这两件事会抑制 mousedown / 把 click 的 target 换掉，挂件就点不开了
    function onDown(e) {
      if (pid !== null) return; // host 和 shadowRoot 会各触发一次
      if (e.pointerType === "mouse" && e.button !== 0) return;
      pid = e.pointerId;
      moving = false;
      sx = e.clientX;
      sy = e.clientY;
      px = x;
      py = y;
      window.addEventListener("pointermove", onMove, { passive: false });
      window.addEventListener("pointerup", onUp);
      window.addEventListener("pointercancel", onUp);
    }

    el.addEventListener("pointerdown", onDown, { passive: true });

    // 图标在 shadow root 里，万一它内部 stopPropagation，host 上就收不到 pointerdown。
    // 在 shadowRoot 的捕获阶段再绑一次兜底（open 的 shadow root 才能拿到）。
    function bindShadowDown() {
      var sr = el.shadowRoot;
      if (!sr || sr.__dragDown) return;
      sr.__dragDown = true;
      sr.addEventListener("pointerdown", onDown, { passive: true, capture: true });
    }
    bindShadowDown();
    setTimeout(bindShadowDown, 800);
    setTimeout(bindShadowDown, 2500);
  }

  /* --------------------------- 启动 --------------------------- */
  function attach(item, el) {
    bindElement(el);
  }

  function boot() {
    TARGETS.forEach(function (item) {
      var el = deepFind(item.sel);
      if (el) {
        attach(item, el);
        return;
      }
      // 挂件是后注入的，等它出现
      var timer = setInterval(function () {
        var found = deepFind(item.sel);
        if (found) {
          clearInterval(timer);
          attach(item, found);
        }
      }, 400);
      setTimeout(function () {
        clearInterval(timer);
      }, 20000);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

(function initQuickCepSmartDrag() {
  const STYLE_ID = "quickcep-drag-override";

  function bindDragLogic(iframe, btn) {
    if (btn.dataset.dragBound === "true") return;
    btn.dataset.dragBound = "true";

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    // 1. 创建全局样式标签
    let styleTag = document.getElementById(STYLE_ID);
    if (!styleTag) {
      styleTag = document.createElement("style");
      styleTag.id = STYLE_ID;
      document.head.appendChild(styleTag);
    }

    let isDragging = false;
    let hasMoved = false;

    let startScreenX = 0,
      startScreenY = 0;
    let initialIframeTop = 0,
      initialIframeLeft = 0;
    let finalTop = 0,
      finalLeft = 0;

    const safeNum = (val, fallback = 0) => (typeof val === "number" && !isNaN(val) ? val : fallback);

    // 🔍 深度检测当前是否为 chatSize1
    const checkIsChatSize1 = () => {
      // 检查按钮本身、所有父级、以及 iframe 内部整个 document 下是否有 chatSize1
      if (btn.closest(".chatSize1")) return true;
      if (iframeDoc.querySelector(".chatSize1")) return true;
      // 有时 class 加在 iframeDoc.body 或者 html 上
      if (iframeDoc.body && iframeDoc.body.classList.contains("chatSize1")) return true;
      return false;
    };

    const getScreenPos = (e) => {
      const touch = e.touches && e.touches[0];
      const src = touch || e;
      return {
        x: safeNum(src.screenX, 0),
        y: safeNum(src.screenY, 0),
      };
    };

    // 🎨 核心：精准渲染样式
    const syncStyle = () => {
      const isExpanded = checkIsChatSize1();

      if (isExpanded) {
        // 如果是展开状态，完全放开 top 覆盖，强制 top: auto !important; left: 0px !important;
        styleTag.innerHTML = `
          #quick-chat-iframe {
            top: auto !important;
            left: 0px !important;
            transform: none !important;
          }
        `;
      } else if (finalTop !== 0 || finalLeft !== 0) {
        // 如果是 bubble 气泡模式且已被拖拽过，强制死锁绝对坐标
        styleTag.innerHTML = `
          #quick-chat-iframe {
            position: fixed !important;
            top: ${finalTop}px !important;
            left: ${finalLeft}px !important;
            bottom: auto !important;
            right: auto !important;
            transform: none !important;
            transition: none !important;
            margin: 0 !important;
            user-select: none !important;
            will-change: top, left !important;
          }
        `;
      } else {
        // 初始 bubble 模式，不做强行覆盖
        styleTag.innerHTML = "";
      }
    };

    // 1. 按下按键
    const handleStart = (e) => {
      if (checkIsChatSize1()) {
        syncStyle();
        return;
      }

      isDragging = true;
      hasMoved = false;

      e.stopPropagation();
      e.stopImmediatePropagation();

      const rect = iframe.getBoundingClientRect();
      initialIframeTop = safeNum(rect.top, 0);
      initialIframeLeft = safeNum(rect.left, 0);

      const pos = getScreenPos(e);
      startScreenX = pos.x;
      startScreenY = pos.y;

      finalTop = initialIframeTop;
      finalLeft = initialIframeLeft;
    };

    // 2. 移动处理
    const handleMove = (e) => {
      if (!isDragging) return;

      if (checkIsChatSize1()) {
        isDragging = false;
        hasMoved = false;
        syncStyle();
        return;
      }

      const pos = getScreenPos(e);
      const deltaX = pos.x - startScreenX;
      const deltaY = pos.y - startScreenY;

      if (Math.abs(deltaX) > 2 || Math.abs(deltaY) > 2) {
        hasMoved = true;
      }

      if (hasMoved) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        finalTop = initialIframeTop + deltaY;
        finalLeft = initialIframeLeft + deltaX;

        syncStyle();
      }
    };

    // 3. 松开鼠标
    const handleEnd = (e) => {
      if (!isDragging) return;

      if (hasMoved && !checkIsChatSize1()) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        syncStyle();
      }

      isDragging = false;
      hasMoved = false;
    };

    // 4. 监听 iframe 内部一切 DOM class 和 属性的变动
    const internalObserver = new MutationObserver(() => {
      syncStyle();
    });

    internalObserver.observe(iframeDoc.documentElement || iframeDoc.body, {
      attributes: true,
      attributeFilter: ["class", "style"],
      subtree: true,
    });

    // 5. 绑定事件
    btn.addEventListener("pointerdown", handleStart, true);
    btn.addEventListener("mousedown", handleStart, true);
    btn.addEventListener("touchstart", handleStart, true);

    [iframeDoc, window].forEach((target) => {
      target.addEventListener("pointermove", handleMove, true);
      target.addEventListener("mousemove", handleMove, true);
      target.addEventListener("touchmove", handleMove, true);

      target.addEventListener("pointerup", handleEnd, true);
      target.addEventListener("mouseup", handleEnd, true);
      target.addEventListener("touchend", handleEnd, true);
    });
  }

  function tryBind() {
    const iframe = document.getElementById("quick-chat-iframe");
    if (!iframe) return false;

    try {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (!iframeDoc) return false;

      const btn = iframeDoc.getElementById("quick-send-btn");
      if (btn) {
        bindDragLogic(iframe, btn);
        return true;
      }
    } catch (e) {}
    return false;
  }

  if (tryBind()) return;

  const timer = setInterval(() => {
    if (tryBind()) clearInterval(timer);
  }, 300);

  const startObserver = () => {
    const targetNode = document.body || document.documentElement;
    if (!targetNode) return;

    const observer = new MutationObserver(() => {
      if (tryBind()) {
        observer.disconnect();
        clearInterval(timer);
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserver);
  } else {
    startObserver();
  }
})();
